import { getEnvironment } from "./environment";

export const toSentenceCase = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const redirectToPaymentPage = () => {
  const { PAYMENT_URL } = getEnvironment();
  if(window.parent){
    window.parent.location.href = PAYMENT_URL;
  }else{
    window.location.href = PAYMENT_URL;
  }
}